import './f2tproductions/style';
import FormStructure from './f2tproductions/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js